

































import { computed, defineComponent } from '@vue/composition-api';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { ButtonType, RainbowColor, ModalSize } from '@getaccept/lib-ui';
import { useIntercomChat } from '@getaccept/lib-shared/src/composables/intercom-chat.composable';
import { storeToRefs } from 'pinia';

import { useSubscriptionStore } from '../store/subscription.store';
import PlansInformation from './PlansInformation.vue';

export default defineComponent({
  components: { PlansInformation },
  props: {
    description: {
      type: String,
      default: '',
    },
  },
  setup(_, { emit }) {
    const { openChat: openIntercomChat } = useIntercomChat();
    const { daysLeft } = storeToRefs(useSubscriptionStore());
    const header = computed(() => `${t('trial_plan_days_left')} ${daysLeft.value}`);

    const openChat = () => {
      openIntercomChat();
      emit('close');
    };

    return {
      RainbowColor,
      header,
      t,
      openChat,
      ButtonType,
      ModalSize,
    };
  },
});
